import React from "react";
import { TextField } from "@mui/material";
import { COLORS } from "common/colors";

const TxtBox = (props: any) => {
  const {
    id,
    name,
    text,
    variant,
    className,
    disabled,
    type,
    placeholder,
    rows,
    accept,
    autoFocus,
    defaultValue,
    value,
    onChange,
    onKeyPress,
    onBlur,
    error,
    helperText,
  } = props;

  return defaultValue ? (
    <TextField
      id={id}
      className={"uiTxt " + (className ? className : "")}
      name={name}
      label={text}
      variant={variant}
      disabled={disabled}
      type={type || "text"}
      placeholder={placeholder}
      rows={rows}
      multiline={rows ? true : false}
      style={{ backgroundColor: disabled ? COLORS.DIM_GRAY : COLORS.WHITE }}
      inputProps={{ accept: accept }}
      autoFocus={autoFocus}
      autoComplete={"off"}
      defaultValue={defaultValue || ""}
      onChange={onChange}
      onBlur={onBlur}
      onKeyUp={onKeyPress}
      error={error}
      helperText={helperText}
    />
  ) : (
    <TextField
      id={id}
      className={"uiTxt " + (className ? className : "")}
      name={name}
      label={text}
      variant={variant}
      disabled={disabled}
      type={type || "text"}
      placeholder={placeholder}
      rows={rows}
      multiline={rows ? true : false}
      style={{ backgroundColor: disabled ? COLORS.DIM_GRAY : COLORS.WHITE }}
      inputProps={{ accept: accept }}
      autoFocus={autoFocus}
      autoComplete={"off"}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      onKeyUp={onKeyPress}
      error={error}
      helperText={helperText}
    />
  );
};

export default TxtBox;
